<template>
  <embedded
    :iframeSrc="iframeSrc"
  />
</template>

<script>
import Embedded from '../custom-components/Embedded.vue'
import AppConstants from '../../constants/app.constants'

export default {
  components: {
    Embedded
  },
  data() {
    return {
      iframeSrc: AppConstants.WEB_RCS_EMBEDDED_URL
    }
  },
  async mounted() {
    await this.getWebRcsSettings()
  },
  methods: {
    /**
     * WebRCS設定をサーバーから取得し、ローカルストレージに保存する非同期関数。
     */
    async getWebRcsSettings() {
      let value = null
      try {
        const res = await this.$axios.get('/get-web-rcs-setting')
        if (res && res.data) {
          value = res.data
        }
      } catch (e) {
        console.log(e)
      }
      localStorage.setItem(AppConstants.STORAGE_WEB_RCS_SETTING, JSON.stringify(value))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/web-rcs/WebRcs.vue